<template>
  <div :class="[$style.reply, $style[theme]]">
    <div
      v-if="isPhotoAttachment || giphy"
      :class="$style.imgWrap"
    >
      <img v-if="isPhotoAttachment" :src="message.attachment.link"  alt="attached image" :class="$style.image">
      <img
        v-if="giphy"
        :src="giphy.images.fixed_width_small_still.url"
        alt="gif"
        :class="$style.image"
      >
    </div>
    <div :class="$style.replyBody">
      <div :class="[$style.replyName]">{{ title }}</div>
      <div :class="[$style.replyText]">{{ replyText }}</div>
    </div>
    <slot />
  </div>
</template>

<script>
import { TYPE_CODE, ATTACHMENT_CODE } from '@/models/Message'
import { EMOJI } from '@/helpers/variables/index'

export default {
  name: 'message-reply',
  props: {
    message: Object,
    theme: String,
    // chat: Object, // user
    isEdit: Boolean
  },
  computed: {
    replyUser () {
      if (this.isEdit) return
      return this.$store.getters['entities/users/find'](this.message.senderId)
    },
    title () {
      if (this.isEdit) return this.$t('chat.editMessage')
      return this.replyUser ? this.replyUser.displayName : ''
    },
    replyText () {
      if (this.message.attachment) return this.message.payload || this.message.attachment.name
      if (this.giphyId) return `${EMOJI.giphy} ${this.$t('messageType.giphy')}`
      const typeMatch = {
        [TYPE_CODE.contact]: `${EMOJI.contact} ${this.$t('messageType.contact')}`,
        [TYPE_CODE.call]: `${EMOJI.call} ${this.$t('messageType.call')}`,
        [TYPE_CODE.voice]: `${EMOJI.voice} ${this.$t('messageType.voice')}`,
        [TYPE_CODE.forward]: this.message.payload.payload
      }
      return typeMatch[this.message.type] || this.message.payload
    },
    giphyId () {
      return this.message.type === TYPE_CODE.giphy ? this.message.payload.giphyId : null
    },
    giphy () {
      return this.$store.getters['giphy/find'](this.giphyId)
    },
    isPhotoAttachment () {
      if (!this.message.attachment) return false
      return this.message.attachment.type === ATTACHMENT_CODE.image
    }
  },
  watch: {
    giphyId: {
      immediate: true,
      handler: 'getGif'
    }
  },
  methods: {
    async getGif (giphyId) {
      if (!giphyId || this.giphy) return
      await this.$store.dispatch('giphy/getById', giphyId)
    }
  }
}
</script>

<style module lang="scss">
.green{
  .replyName{
    color: $white;
  }
  &.reply {
    border-left: 2px solid $white;
  }
}
.reply {
  border-left: 2px solid $text-colored;
  padding-left: 8px;
  margin-bottom: 6px;
  display: flex;
  width: 100%;
  &Body {
    flex-grow: 1;
    min-width: 0;
  }
  &Name {
    font-weight: 500;
    color: $text-colored;
    margin-bottom: 4px;
  }
  &Name,
  &Text {
    white-space: nowrap;// pre-wrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.imgWrap {
  width: 44px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.image {
  max-width: 44px;
  max-height: 36px;
}
</style>
